import React, { Component } from 'react';
import { Form, Control, Errors } from "react-redux-form";
import {isRequired, minLength, minLength2} from "../field_validations";
import _ from 'lodash';

class EntityEditForm extends Component{
	render(){
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="entities.edit" onSubmit={(entity) => this._handleSubmit(entity)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre <span className="small has-text-danger">*</span></label>
								<Control.text model=".name" id=".name" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Campo Requerido'}}/>
							</div>

							<div className="control">
								<label htmlFor="short" className="label">Abreviatura <span className="small has-text-danger">*</span></label>
								<Control.text model=".short" id="short" className="input" errors={{isRequired, minLength: minLength(3)}} validateOn="change"/>
								<Errors model=".short" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength: 'Abreviatura no valido'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="code" className="label">Código <span className="small has-text-danger">*</span></label>
								<Control.text model=".code" id="code" className="input" errors={{isRequired, minLength2}} validateOn="change"/>
								<Errors model=".code" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength2: 'Codigo no valido'}} />
							</div>

							{/*<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".status_id" id="status" className="select" errors={{required}} validateOn="change">
										<option value="" defaultValue>--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>*/}

							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="accessibility" className="checkbox">
													<Control.checkbox model=".accessibility" id="accessibility" className="checkbox" isToggle={true} />
													<span style={{whiteSpace:'normal'}}> Requiere ayuda visual </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<Control.button model="entities.edit" className="button is-large" onClick={() => this.props.history.push('/entidades')}>Regresar</Control.button>
							</div>
							<div className="control">
								<Control.button model="entities.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values){
		this.props.entitySave(values)
	}

	_validateSave(){
		const {entities} = this.props;
		let ec = _.find(entities.permissions, (o) => {return o==='Create'});
		let eu = _.find(entities.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(entities.edit) && entities.edit.id){
			if(eu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(entities.edit) && _.isEmpty(entities.edit.id)){
			if(ec){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default EntityEditForm;


// WEBPACK FOOTER //
// ./src/elements/entities/form.jsx